var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveDepartures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "2864c45b-6b1c-4c3d-9c10-cb0853ce9b97",
    d: "M17.623 23.303h3.825v-1.31h-3.825v1.31zm0-3.1h3.825v-1.312h-3.825v1.312zm0 6.2h3.825v-1.312h-3.825v1.312zm-13.149-3.1h11.464v-1.31H4.474v1.31zm0 3.1h11.464v-1.312H4.474v1.312zm0-6.2h11.464v-1.312H4.474v1.312zm19.668-2.257v9.583c0 .62-.499 1.123-1.11 1.123H2.442c-.612 0-1.11-.504-1.11-1.123V16.55h16.154A6.747 6.747 0 0 1 15.7 9.334H.888a.894.894 0 0 0-.888.899v17.296C0 28.893 1.095 30 2.441 30h20.591c1.348 0 2.442-1.107 2.442-2.47V17.303c-.416.261-.86.476-1.332.642zm-5.25-6.317c0 1.734 1.419 3.138 3.166 3.138 1.75 0 3.166-1.403 3.166-3.138 0-1.733-1.42-3.138-3.166-3.138-1.747 0-3.166 1.405-3.166 3.138zm2.889-6.806l-.042.953c-.009.214.144.406.36.416 1.27.143 2.51.7 3.484 1.666a5.793 5.793 0 0 1 1.682 3.454c.03.212.204.364.42.354l.964-.04c.237-.012.399-.213.378-.458a7.52 7.52 0 0 0-2.192-4.548 7.603 7.603 0 0 0-4.646-2.176.416.416 0 0 0-.408.379zm.154-2.937l-.042.955a.405.405 0 0 0 .38.417 8.813 8.813 0 0 1 5.42 2.53 8.718 8.718 0 0 1 2.55 5.37.405.405 0 0 0 .422.377l.964-.04a.424.424 0 0 0 .37-.447 10.412 10.412 0 0 0-3.064-6.51A10.557 10.557 0 0 0 22.328 1.5a.397.397 0 0 0-.393.386z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.947)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b2864c45b-6b1c-4c3d-9c10-cb0853ce9b97",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2864c45b-6b1c-4c3d-9c10-cb0853ce9b97"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#2864c45b-6b1c-4c3d-9c10-cb0853ce9b97"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#b2864c45b-6b1c-4c3d-9c10-cb0853ce9b97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDepartures);
export default __webpack_public_path__ + "static/media/live-departures.cf7fbdbaeb94fc51699731dd9fc7490c.svg";
export { ForwardRef as ReactComponent };